<template>
  <cs-basic>
    <template v-slot:header>
      <login-header />
    </template>
    <template v-slot:content>
      <background-wrapper>
        <SuccessfulLink v-if="isSend" />
        <div class="text-center justify-center painel" v-else>
          <h1 class="link-text">Ops! O link expirou</h1>
          <p class="mt-8">
            Insira abaixo o seu login para solicitar um novo link.
            <br /><strong>Lembre-se: </strong> o link é válido por duas horas.
          </p>
          <cs-message v-if="responseErrors" v-model="responseErrors" />
          <v-form>
            <cs-text-field
              id="PasswordForm"
              v-model="login"
              label="Login"
              :error-messages="loginErrors"
              @change="validateField"
              @keydown="resetResponseErrors"
              required
            />
            <cs-recaptcha
              ref="vue_recaptcha"
              class="recaptcha"
              v-model="recaptcha"
              :sitekey="global.recaptchaKey"
            />
            <request
              id="solicitar_link"
              method="post"
              class="w-100 mt-6"
              :headers="headers"
              :url="global.sendEmailResetPasswordUrl"
              :value="payload"
              :disabled="formIsInvalid"
              :loading="loading"
              @resolved="resolved"
            >
              Solicitar novo link
            </request>
          </v-form>
        </div>
      </background-wrapper>
    </template>
    <template v-slot:footer>
      <login-footer />
    </template>
  </cs-basic>
</template>

<script>
import csBasic from '@/layouts/csBasic.vue'
import loginHeader from '@/components/header/loginHeader.vue'
import loginFooter from '@/components/loginFooter.vue'
import SuccessfulLink from '@/components/SuccessfulLink.vue'
import Request from '@/components/Request.vue'
import csTextField from '@/components/campos/csTextField.vue'
import csMessage from '@/components/campos/csMessage.vue'
import csRecaptcha from '@/components/campos/csRecaptcha.vue'
import BackgroundWrapper from '@/components/background/BackgroundWrapper.vue'
import loginService from '@/services/loginService'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapState } from 'vuex'

export default {
  mixins: [loginService, validationMixin],
  validations() {
    return {
      login: { required }
    }
  },
  components: {
    csBasic,
    loginHeader,
    loginFooter,
    csRecaptcha,
    csMessage,
    csTextField,
    Request,
    SuccessfulLink,
    BackgroundWrapper
  },
  props: {
    token: {
      type: String,
      required: true
    },
    expiredPassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      login: '',
      recaptcha: '',
      isSend: false,
      responseErrors: [],
      loading: false
    }
  },
  computed: {
    ...mapState(['global']),
    loginErrors() {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.required && errors.push('Esse campo é obrigatório.')
      return errors
    },
    formIsInvalid() {
      return !(this.login && this.recaptcha && this.loginErrors.length === 0)
    },
    headers() {
      const contentHeader = { 'Content-Type': 'application/json' }
      if (this.requestToken) {
        contentHeader.RequestVerificationToken = this.requestToken
      }
      return contentHeader
    },
    payload() {
      return {
        login: this.login,
        recaptcha: this.recaptcha
      }
    }
  },
  methods: {
    validateField() {
      this.$v.login.$touch()
    },
    resolved(response) {
      this.resetResponseErrors()
      if (response.status === 200) {
        this.isSend = true
        return
      }
      this.responseErrors.push(response.data.errors[''][0])
      this.$refs.vue_recaptcha.reset()
      this.recaptcha = ''
    },
    resetResponseErrors() {
      this.responseErrors = []
    },
    handleGoBack() {
      this.$router.go(this.$route.currentRoute)
    }
  }
}
</script>

<style>
.link-text {
  margin-top: 80px;
}

.recaptcha {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
